import { Flex, Group, Text, UnstyledButton } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';

import { useAdminSignOut } from '@admin/hooks';
import { Logo } from '@components';
import classes from '@features/layout/UserLayout/Header/Header.module.css';
import { useSettings } from '@hooks/useSettings';

export const AdminHeader = () => {
  const { data: settings } = useSettings();
  const navigate = useNavigate();
  const signOutMutation = useAdminSignOut(() => navigate('/admin/auth'));

  const badgeDetails = settings?.isForwarder
    ? { badge: 'Customs Trade Admin', badgeColor: '#ECCC38' }
    : { badge: 'Customs Clear Admin', badgeColor: '#C0E5C9' };

  const handleLogout = () => signOutMutation.mutate();

  return (
    <Flex className={classes.headerContainer}>
      <Flex className={classes.logoContainer}>
        <Link to="/">
          <Logo badge={badgeDetails.badge} badgeColor={badgeDetails.badgeColor} />
        </Link>
      </Flex>
      <UnstyledButton onClick={handleLogout} disabled={signOutMutation.isPending} pr={40}>
        <Group gap={8}>
          <IconLogout size={18} stroke={1.5} />
          <Text>Logout</Text>
        </Group>
      </UnstyledButton>
    </Flex>
  );
};
